<template>
  <div>
    <div class="alert alert-secondary" :class="'text-'+alinhaBtn" role="alert" v-show="exibe_botao">
      <button type="button" @click="$emit('click_bt_modal')" class="btn btn-primary" data-bs-toggle="modal"
        :id="['btn_' + id_modal]" :data-bs-target="['#' + id_modal]">
        {{ textoBtnChamada }}
      </button>
    </div>

    <div :class="'text-'+alinhaBtn" role="alert" v-show="exibe_link">
      <button type="button" @click="$emit('click_bt_modal')" class="btn btn-info btn-sm" data-bs-toggle="modal"
        :id="['btn_' + id_modal]" :data-bs-target="['#' + id_modal]">
        {{ textoBtnChamada }}
      </button>
    </div>

    <!-- Modal -->
    <div class="modal fade" :id="id_modal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
      aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div :class="['modal-dialog', 'modal-dialog-scrollable', tamanho_modal]">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="staticBackdropLabel">{{ tituloModal }}</h1>
            <button type="button" class="btn-close" :id="['btn_close_' + id_modal]" data-bs-dismiss="modal"
              aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <slot></slot>
          </div>
          <div class="modal-footer">
            <fieldset>
              <input type="button" class="btn btn-secondary btn-salvar" @click="$emit('fecha_modal')"
                data-bs-dismiss="modal" value="Fechar">
            </fieldset>
            <slot name="botaoPersonalizado"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    id_modal: {
      default: 'modal_cadastrar'
    },
    textoBtnChamada: {
      default: 'Cadastrar'
    },
    tituloModal: {
      default: 'Cadastrar'
    },
    tamanho_modal: {
      default: 'modal-xl'
    },
    exibe_botao: {
      default: true
    },
    exibe_link: {
      default: false
    },
    alinhaBtn: {
      default: 'start'
    },
  },
  data() {
    return {

    }
  },
  mounted() {
    const modal = document.getElementById(this.id_modal)
    modal.addEventListener('hidden.bs.modal', event => {
      this.$emit('hidden')
    })
    modal.addEventListener('hide.bs.modal', event => {
      this.$emit('hide')
    })
  },
  computed: {
  },
  components: {

  }
}
</script>

<style scoped></style>